export default "__VITE_ASSET__cYIOTbDN__"